import { UseFormReturn } from 'react-hook-form';

import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { ObjectInput } from '../../../shared/field-inputs/ObjectInput';

interface ObjectFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function ObjectFieldRenderer({ fieldKey, field, form, label, disabled = false }: ObjectFieldRendererProps) {
  const definition = field.definition;

  if (definition.type !== 'object') {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <ObjectInput
            value={formField.value || ''}
            onChange={formField.onChange}
            label={label}
            placeholder={`Enter ${fieldKey}...`}
            disabled={disabled}
            // height='800px'
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
